'use client';

import { CheckCircle2 } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

export default function Process() {
  const { t } = useLanguage();

  const steps = [
    {
      number: '01',
      title: t('process.step.1.title'),
      description: t('process.step.1.desc'),
    },
    {
      number: '02',
      title: t('process.step.2.title'),
      description: t('process.step.2.desc'),
    },
    {
      number: '03',
      title: t('process.step.3.title'),
      description: t('process.step.3.desc'),
    },
    {
      number: '04',
      title: t('process.step.4.title'),
      description: t('process.step.4.desc'),
    },
  ];

  return (
    <section id="process" className="py-24 bg-black relative overflow-hidden">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-0 w-[500px] h-[500px] bg-[#006546] rounded-full blur-[150px] opacity-5 -translate-y-1/2 -translate-x-1/2 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-3xl md:text-5xl font-semibold mb-8">
              {t('process.title.1')} <br />
              <span className="text-[#19ffb5]">{t('process.title.2')}</span>
            </h2>
            <p className="text-gray-300 text-lg mb-8 font-light">
              {t('process.description')}
            </p>
            <ul className="space-y-4">
              {[
                t('process.list.1'),
                t('process.list.2'),
                t('process.list.3'),
                t('process.list.4'),
              ].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-white font-medium">
                  <CheckCircle2 className="w-5 h-5 text-[#19ffb5] shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="grid gap-6">
            {steps.map((step, index) => (
              <div
                key={index}
                className="flex gap-6 p-6 rounded-xl bg-white/5 border border-white/10 hover:bg-white/[0.07] transition-colors"
              >
                <span
                  className="text-4xl font-semibold shrink-0"
                  style={{
                    background: 'linear-gradient(135deg, #006546 0%, #19ffb5 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                  }}
                >
                  {step.number}
                </span>
                <div>
                  <h3 className="text-xl font-semibold mb-2 text-white">{step.title}</h3>
                  <p className="text-gray-300 text-sm leading-relaxed font-light">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
